<template> 
    <form class="form form_w400 form_pt100 form_pt_m60" @submit.prevent="forgot">  
        <div class="form__head">
            <h2 class="form__title form__title_mb16">Restore password</h2>
        </div>

        <div class="form__content"> 
            <div class="form-item mb24"> 
                <el-input 
                    placeholder="Email"
                    type="text" 
                    v-model="form.email"
                    autocomplete="off"
                ></el-input>
            </div>
                
            <div class="form-item">
                <button 
                    class="btn btn_upper" 
                    :disabled="true"
                    :class="{
                        'btn_disabled': true
                    }"
                >Send</button>
            </div> 

            <!-- <div class="form-item">
                <div class="form-item__cta mb24">
                    <p class="form-item__text">
                        Already have an account? Login
                        <router-link 
                            class="form-item__link"
                            to="/auth/login"
                            tag="a"
                        >
                            {{$t("auth.login")}}
                        </router-link>
                    </p>
                </div>
                
                <div class="form-item__cta">
                    <p class="form-item__text">
                        Don’t have an account yet? 
                        <router-link 
                            class="form-item__link"
                            to="/auth/signup"
                            tag="a"
                        >
                            {{$t('auth.signup')}}
                        </router-link>
                    </p>
                </div> 
            </div> -->
        </div>
    </form>
</template>

<script>
export default {
    name: 'authForgot',
    data() {
        return {
            form: {}
        }
    },
    methods: {
        forgot() {}
    }
}
</script>  